import { api } from './api';

export interface CatalogsResponse {
  brands: Brand[];
  presentations: Brand[];
  volumes: Brand[];
  quantities: Brand[];
  typologies: Brand[];
  sizes: Brand[];
}
export interface Brand {
  id: string | number;
  name: string;
  description: null;
  is_active: boolean;
}

export const catalogService = {
  getCatalogs: async (): Promise<CatalogsResponse> => {
    try {
      const response = await api.get('/catalogs');
      return response.data;
    } catch (error) {
      console.error('Error al obtener catálogos:', error);
      throw error;
    }
  }
};
